// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchResults/SearchResultsTransaction/SearchResultsTransaction.css
// module id = 1424
// module chunks = 0